import React from 'react'
import { connect } from 'react-redux'
import { showSplashScreen } from '../slices/ui'
import { errorReporing } from '../utils'
import Icons from '../images/error.svg'
import {
  APPLICATION_ERROR,
  APPLICATION_ERROR_MESSAGE,
  RELOAD
} from '../trans'


class ErrorManager extends React.PureComponent {

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch (error, errorInfo) {
    this.props.hideSplahScreen()
    const errorlog = {
      'error': error.message,
      'stack': errorInfo.componentStack
    }
    errorReporing(errorlog)
  }

  render () {
    if (!this.state?.hasError) {
      return this.props.children
    }
    return (
      <div className="pwa__error fade-in">
        <div className="content fade-in delay">
          <Icons/>
          <h2>
            {APPLICATION_ERROR}
          </h2>
          <p>
            {APPLICATION_ERROR_MESSAGE }
          </p>
          <button className="button secondary" onClick={() => window.location.reload(true)}>
            {RELOAD}
          </button>
        </div>
      </div>
    )
  }
}

const ConnectedErrorManager = connect(
  null,
  (dispatch) => ({
    hideSplahScreen: () => {
      dispatch(showSplashScreen(false))
    }
  })
)(ErrorManager)

export default ConnectedErrorManager
